import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import type { TimelineEvent } from '@/types/api'

export type TimelineEntityType = 'party' | 'opportunity'

export function timelineQueryKey(entityType: string, entityId: string) {
  return ['timeline', entityType, entityId] as const
}

/**
 * The unified timeline (Task 6 API) — merges activity_log + notes + opportunity
 * audit_log lifecycle events into one newest-first feed for an entity. Backs the
 * single Timeline component mounted on ContactDetail and OpportunityDetail.
 */
export function useTimeline(entityType: TimelineEntityType, entityId: string) {
  return useQuery({
    queryKey: timelineQueryKey(entityType, entityId),
    queryFn: async () => {
      const data = await api.get<{ events: TimelineEvent[] }>(
        `/timeline?entity_type=${entityType}&entity_id=${entityId}`,
      )
      return data.events
    },
    enabled: Boolean(entityId),
  })
}
